import { connect } from 'react-redux';
import ModemDelivery from '../../components/checkout/ModemDelivery/ModemDelivery';

// TODO this is the same in ConnectionDate, ModemDelivery and CurrentConnection
// Refactor this into a common component
const mapStateToProps = (state, ownProps) => {
  if (state.form.checkout.values) {
    const modemDelivery = state.form.checkout.values.modemDelivery;
    if (modemDelivery && modemDelivery === 'different') {
      return { showModemDeliveryAddress: true, props: ownProps };
    }
  }

  return { props: ownProps };
};

const ModemDeliveryContainer = connect(mapStateToProps)(ModemDelivery);

export default ModemDeliveryContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ModemDeliveryContainer.js
 **/